var _rect, _rect2, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAccountActivation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 8,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 32,
    height: 32,
    rx: 6,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9459 31.1911C30.7462 32.9632 28.3987 34.5437 25.9293 35.9152C25.2639 36.3678 24.5151 36.6835 23.7265 36.8439C22.8248 36.92 21.9214 36.7181 21.1379 36.2652C21.1379 36.2652 21.1065 36.2652 21.0975 36.2382C20.8867 36.1351 20.6803 36.0184 20.4739 35.8973C18.2308 34.5514 16.2523 32.5774 15.4134 30.092C15.2624 29.6353 15.1484 29.1672 15.0724 28.6922C14.8697 27.3196 14.9568 25.9197 15.3281 24.5828C15.8494 22.7782 16.7487 21.1052 17.9661 19.6747C19.3901 17.8654 21.3157 16.5156 23.5022 15.7941C24.3562 15.5329 25.2428 15.3939 26.1357 15.3813C28.8275 15.3454 31.5507 16.3235 33.9419 17.6245C34.4045 17.8696 34.8538 18.1392 35.2878 18.432C36.0849 18.9345 36.7841 19.5775 37.3515 20.3297C40.0433 24.1655 35.7409 28.8044 32.9459 31.1911Z",
    fill: "#F08E0F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9957 33.6812C33.2085 34.6052 32.2656 35.3841 31.2097 35.9827L31.1514 36.0141C28.4998 37.5157 25.3603 37.9025 22.4236 37.0893C19.4869 36.2761 16.9934 34.3297 15.4918 31.6781C13.9903 29.0265 13.6035 25.8871 14.4167 22.9503C15.2298 20.0136 17.1763 17.5202 19.8279 16.0186L19.9625 15.9423C26.1042 12.4879 33.1478 13.7575 36.0056 18.827C36.8196 20.3499 37.2797 22.0367 37.3515 23.762",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1702 20.9888L23.738 32.2131",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1697 19.6553L30.4494 30.578",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAccountActivation);
export default __webpack_public_path__ + "static/media/icon-account-activation.e66ab270d0b332a6e9f6f86e52a56c2c.svg";
export { ForwardRef as ReactComponent };